import React, { useContext, useCallback } from "react";
import { UI } from "@wwimmo/ui";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { RootStoreContext } from "src/stores/RootStore";
import { useTranslation } from "react-i18next";
import { DeleteInvoiceModal } from "./modal/DeleteInvoiceModal";
import { RESTART_CANCEL_MODAL_TYPE } from "src/stores/krediflow/RestartCancelInvoiceStore";

const DeleteInvoiceBase = () => {
    const { restartCancelInvoiceStore, invoiceStore } = useContext(RootStoreContext);
    const { t } = useTranslation();

    const displayDeleteInvoiceModal = useCallback(() => {
        restartCancelInvoiceStore.setIsModalDisplayed(true);
        restartCancelInvoiceStore.setDisplayedModalType(RESTART_CANCEL_MODAL_TYPE.DELETE);
    }, [restartCancelInvoiceStore]);

    return (
        <>
            <UI.Button
                label={t("screens.kredi_flow.action.delete")}
                className={"mb-2"}
                onClick={displayDeleteInvoiceModal}
                variant="danger"
                hidden={!invoiceStore.currentInvoice?.canCurrentUserDelete}
            />
            <DeleteInvoiceModal />
        </>
    );
};

export const DeleteInvoice = Sentry.withProfiler(observer(DeleteInvoiceBase));
